import styled from 'styled-components';
import {interceptProps} from '@/styled-components/utils';
import {palette} from '@/styles';

export interface PointDotProps {
  size?: number;
  filled?: boolean;
  borderColor?: string;
  borderWidth?: number;
}

export const Dot = styled('div').withConfig({
  shouldForwardProp: interceptProps([
    'size',
    'filled',
    'borderColor',
    'borderWidth',
  ]),
})<PointDotProps>`
  ${({size = 12, borderWidth = 2}) => `
    width: ${size}px;
    height: ${size}px;
    margin-top: -${size / 2}px;
    margin-left: -${size / 2}px;
    border: solid ${borderWidth}px;
  `}
  box-sizing: border-box;
  border-color: ${({borderColor = palette.blue100}) => borderColor};
  background-color: ${({filled, borderColor = palette.blue100}) =>
    filled ? borderColor : palette.white};
  border-radius: 100%;
`;
